import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './QandAComponent.css';
import { AnswererRoles } from '../../Utils/Constants';
import { getSafeTimeWithZone } from '../../Utils/MomentUtils';

class QandAComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool,
    timeZone: PropTypes.string,
    qAndAInfo: PropTypes.shape({
      question: PropTypes.string,
      askedBy: PropTypes.string,
      askerKey: PropTypes.string,
      dateAsked: PropTypes.string,
      answers: PropTypes.arrayOf(
        PropTypes.shape({
          answer: PropTypes.string,
          answeredBy: PropTypes.string,
          answererRole: PropTypes.string,
          answerTime: PropTypes.string,
          answererEmail: PropTypes.string
        })
      ).isRequired,
      totalQuestions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      currentQuestionIndex: PropTypes.number.isRequired
    })
  };

  render() {
    const qAndAInfo = this.props.qAndAInfo;
    const { t } = this.context;
    return (
      <div className="qAndAPanel">
        <div className="qAndACard">
          {qAndAInfo.answers.length > 0 && (
            <div className="answeredPanel">
              <span className="answeredIcon" />
              <span className="answeredText">{t('engagement.answered')}</span>
            </div>
          )}
          <div className="qAndAHeader">
            <div>
              <span className="qAndACount">
                {t('engagement.questionsCount', {
                  currentQuestionIndex: qAndAInfo.currentQuestionIndex,
                  totalQuestions: qAndAInfo.totalQuestions
                })}
              </span>
            </div>
            <div>{getSafeTimeWithZone(qAndAInfo.dateAsked, this.props.timeZone)}</div>
          </div>
          <div className="qAPanel">
            <div className="questionPanel">
              <span className="qAHighlight">{t('engagement.questionShort')}</span>

              <span className="alignQAndADetails">
                <div>{qAndAInfo.question}</div>
                <span className="qAndAText">{t('engagement.questionAskedBy')}</span>
                <a href={`mailto:${qAndAInfo.askedBy}`}>{qAndAInfo.askedBy}</a>
              </span>
            </div>
            {qAndAInfo.answers.length > 0 && (
              <div className="questionPanel">
                <div className="qAHighlight">{t('engagement.answerShort')}</div>
                <div className="answerPanel">{this.displayQAndA(qAndAInfo)}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  displayQAndA = qAndAInfo => {
    let answererRole = null;
    const { t } = this.context;
    return qAndAInfo.answers.map((item, index) => {
      switch (item.answererRole) {
        case AnswererRoles.INTERNAL_ORGANIZER:
          answererRole = t('engagement.questionAnsweredByOrganizer');
          break;
        case AnswererRoles.PANELIST:
          answererRole = t('engagement.questionAnsweredByPanelist');
          break;
        case AnswererRoles.EXTERNAL_ORGANIZER:
          answererRole = t('engagement.questionAnsweredByExternalOrganizer');
          break;
        default:
          answererRole = t('engagement.questionAnsweredBy');
          break;
      }

      return (
        <div className="alignQAndADetails" key={index}>
          <div>{item.answer}</div>
          <span className="qAndAText">{answererRole}</span>
          <a href={`mailto:${item.answererEmail}`}>{item.answererEmail}</a>
        </div>
      );
    });
  };
}

export default QandAComponent;



// WEBPACK FOOTER //
// ./src/Components/QandAComponent/QandAComponent.js